import React, { useEffect } from "react";
import { GeneralModal, useModalAlert } from "../GeneralComponents";
import { DobleAutenticacion } from "../GdDocumentation/DobleAutenticacion";

export function RegisterForm({ openModal, handleCloseModal }) {
  const [listCountries, setListCountries] = React.useState([]);
  const [listDepartments, setListDepartments] = React.useState([]);
  const [listCities, setListCities] = React.useState([]);
  const [listTipoPersona, setListTipoPersona] = React.useState([]);
  const [listTipoContribuyente, setListTipoContribuyente] = React.useState([]);
  const [listTipoDocumentos, setListTipoDocumentos] = React.useState([]);
  const [listDocumentosConvocatoria, setListDocumentosConvocatoria] =
    React.useState([]);
  const [listListActEco, setListActEco] = React.useState([]);
  const [openModalRegistro, setOpenModalRegistro] = React.useState(false);
  const [idProveedor, setIdProveedor] = React.useState(null);
  const { showModalAlert } = useModalAlert();

  const [formData, setFormData] = React.useState({
    id_pais: 38,
    id_dpto: 26,
  });
  const pais = formData.id_pais;
  const id_dep = formData.id_dpto;

  useEffect(() => {
    loadCountries();
    loadTipoPersona();
    loadTipoContibuyente();
    loadTiposDocumentos();
    loadDocumentosConvocatoria();
    loadActividadesEconomicas();
  }, []);

  useEffect(() => {
    if (pais) {
      loadDepartments();
    }
  }, [pais]);

  useEffect(() => {
    if (id_dep) {
      loadCities();
    }
  }, [id_dep]);

  const loadActividadesEconomicas = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "actividades-economicas/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaActividadesEconomicas = data.map((unidad) => {
          return {
            value: unidad.id,
            label: unidad.nombre,
            codigo: unidad.codigo,
          };
        });
        setListActEco(listaActividadesEconomicas);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadDocumentosConvocatoria = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "documentos-convocatoria/listar?requerido_en_registro=true",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaDocConvocatoria = data.map((documento) => {
          return {
            value: documento.id,
            label: documento.nombre,
          };
        });
        setListDocumentosConvocatoria(listaDocConvocatoria);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadTiposDocumentos = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "tipo-documento/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaTipoDocumento = data.map((tipoDoc) => {
          return {
            value: tipoDoc.id,
            label: tipoDoc.nombre,
          };
        });
        setListTipoDocumentos(listaTipoDocumento);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadTipoContibuyente = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "tipo-contribuyente/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaTipoContribuyente = data.map((unidad) => {
          return {
            value: unidad.id,
            label: unidad.nombre,
          };
        });
        setListTipoContribuyente(listaTipoContribuyente);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadTipoPersona = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "tipo-persona/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaTipoPersona = data.map((unidad) => {
          return {
            value: unidad.id,
            label: unidad.nombre,
          };
        });
        setListTipoPersona(listaTipoPersona);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadCountries = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "paises/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listCountries = data.map((pais) => {
          return {
            value: pais.id,
            label: pais.painom,
          };
        });
        setListCountries(listCountries);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadDepartments = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "departamentos/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listDepartments = data.map((departamento) => {
          return {
            value: departamento.id,
            label: departamento.depnom,
          };
        });
        setListDepartments(listDepartments);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadCities = async () => {
    var data = { id_dep: id_dep };
    await fetch(process.env.REACT_APP_PUBLIC_URL + "ciudades/listar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("ciudades", data);
        const listCities = data.map((city) => {
          return {
            value: city.id,
            label: city.ciunom,
          };
        });
        setListCities(listCities);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const newModalField = [
    {
      name: "usuario",
      label: "Correo electrónico de usuario",
      type: "text",
      //hidden: isEditMode,
    },
    {
      name: "password",
      label: "Contraseña",
      type: "password",
      //hidden: isEditMode,
    },
    {
      name: "password2",
      label: "Confirma Contraseña",
      type: "password",
      //hidden: isEditMode,
    },
    {
      name: "tipo_persona",
      label: "Tipo persona",
      type: "select",
      options: listTipoPersona,
    },
    {
      name: "nit",
      label: "Nit/Cédula de ciudadanía",
      type: "text",
    },
    { name: "razon_social", label: "Razon social", type: "text" },
    {
      name: "tipo_contribuyente",
      label: "Tipo de contribuyente",
      type: "select",
      options: listTipoContribuyente,
    },
    { type: "parrafo", label: "Sujecto de retención" },
    { name: "renta", label: "Renta", type: "radio" },
    { name: "iva", label: "IVA", type: "radio" },
    {
      name: "codigo_ciiu_principal",
      label: "Codigo CIIU principal",
      type: "autocomplete-texto",
      options: listListActEco,
    },
    {
      name: "codigo_ciiu_actividad2",
      label: "Codigo CIIU actividad 2",
      type: "autocomplete-texto",
      options: listListActEco,
    },
    {
      name: "codigo_ciiu_actividad3",
      label: "Codigo CIIU actividad 3",
      type: "autocomplete-texto",
      options: listListActEco,
    },
    {
      name: "codigo_ciiu_actividad4",
      label: "Codigo CIIU actividad 4",
      type: "autocomplete-texto",
      options: listListActEco,
    },
    {
      type: "label",
      label: "Datos de contacto del proveedor",
    },
    { name: "id_pais", label: "País", type: "select", options: listCountries },
    {
      name: "id_dpto",
      label: "Departamento",
      type: "select",
      options: listDepartments,
    },
    { name: "id_ciudad", label: "Ciudad", type: "select", options: listCities },
    {
      name: "direccion",
      label: "Dirección",
      type: "text",
    },
    {
      name: "celular",
      label: "Celular",
      type: "number",
    },
    {
      name: "email",
      label: "Correo electrónico",
      type: "email",
    },
    {
      type: "label",
      label: "Datos del representante legal ",
    },
    {
      name: "id_tipo_documento",
      label: "Tipo de documento",
      type: "select",
      options: listTipoDocumentos,
    },
    {
      name: "numero_identificacion",
      label: "Número de documento",
      type: "mayuscula",
    },
    {
      name: "nombre",
      label: "Nombre completo",
      type: "text",
    },
    {
      name: "cargo",
      label: "Cargo",
      type: "text",
    },
    {
      name: "celular_representante",
      label: "Celular",
      type: "number",
    },
    {
      name: "email_representante",
      label: "Correo electrónico",
      type: "email",
    },
    {
      type: "label",
      label: "Documentos requeridos para la creación de la cuenta",
    },
    {
      name: "documentos_convocatoria",
      type: "list-documentos",
      options: listDocumentosConvocatoria,
    },
    {
      name: "autorizacion_datos",
      label: "Autorizo el tratamiento de mis datos personales",
      type: "checkbox-boolean",
      required: true,
    },
    {
      name: "link_terminos",
      type: "link",
      text: "Ver términos y condiciones",
      onClick: () => {
        handleOpenDocument();
      },
    },
  ];

  const requiredFields = [
    "usuario",
    "password",
    "password2",
    "tipo_persona",
    "nit",
    "razon_social",
    "tipo_contribuyente",
    "renta",
    "iva",
    "codigo_ciiu_principal",
    "codigo_ciiu_actividad2",
    "id_dpto",
    "id_pais",
    "id_ciudad",
    "direccion",
    "celular",
    "email",
    "id_tipo_documento",
    "numero_identificacion",
    "nombre",
    "cargo",
    "celular_representante",
    "email_representante",
    "autorizacion_datos",
  ];

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleCloseModalRegister = () => {
    setOpenModalRegistro(false);
  };

  const handleFieldChangeMini = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value.toLowerCase(),
    }));
  };

  const handleOpenDocument = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_PUBLIC_URL +
          "terminos-condiciones/cargar-terminos",
        {
          responseType: "blob",
        },
      );

      const blob = await response.blob();
      const fileURL = URL.createObjectURL(blob);

      window.open(fileURL, "_blank");
    } catch (error) {
      console.error("Error al cargar los términos y condiciones:", error);
      alert(
        "No se pudieron cargar los términos y condiciones en este momento.",
      );
    }
  };

  const handleFieldChangeMay = async (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value.toUpperCase(),
    }));
  };

  const sendCorreo = async (id_proveedor) => {
    try {
      let dataSend = {
        id_proveedor: id_proveedor,
      };
      await fetch(
        process.env.REACT_APP_PUBLIC_URL + "doble-autenticacion/generaOTP",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(dataSend),
        },
      );
    } catch (error) {
      showModalAlert("danger", "Error enviando el correo");
    }
  };

  async function handleSave(formData, selectedFiles) {
    try {
      const dataToSend = new FormData();

      Object.keys(formData).forEach((key) => {
        dataToSend.append(key, formData[key]);
      });

      Object.keys(selectedFiles).forEach((documentType) => {
        dataToSend.append(documentType, selectedFiles[documentType]);
      });

      const updateResponse = await fetch(
        process.env.REACT_APP_PUBLIC_URL + "proveedores-cuentas/create",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: dataToSend,
        },
      );
      if (!updateResponse.ok) {
        const errorData = await updateResponse.json();
        throw new Error(errorData.message || "Error en el servidor");
      }
      const result = await updateResponse.json();
      handleCloseModal()
      showModalAlert("success", "Se registro correctamente el proveedor");

      //sendCorreo(result.id);
      setIdProveedor(result.id);
      //setOpenModalRegistro(true);
    } catch (error) {
      console.log("error...", error);
      showModalAlert("danger", "Error al crear el proveedor");
    }
  }

  return (
    <>
      <GeneralModal
        open={openModal}
        titleAlert={"cuenta"}
        onClose={handleCloseModal}
        fields={newModalField}
        formData={formData}
        onFieldChange={handleFieldChange}
        onFieldChangeMini={handleFieldChangeMini}
        onFieldChangeMay={handleFieldChangeMay}
        setFormData={setFormData}
        isModalRadication={true}
        isRadicacion={true}
        width={"70%"}
        requiredFields={requiredFields}
        onSave={handleSave}
        isRegister={true}
        initialFormData={{
          id_pais: 38,
          id_dep: 26,
        }}
        title={"crear cuenta"}
      />
      {/* {openModalRegistro && (
        <DobleAutenticacion
          openModal={openModalRegistro}
          handleCloseModal={handleCloseModalRegister}
          idProveedor={idProveedor}
          handleCloseModalForm={handleCloseModal}
        />
      )} */}
    </>
  );
}
